<div class="partner-slider" *ngIf="sliderItems && sliderItems.length">

  <div class="left-arrow" (click)="previous()">
    <i class="far fa-chevron-left fa-3x left-arrow-icon"></i>
  </div>

  <!-- slide -->
  <div class="slider-items" fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-md="space-between center"
    fxLayoutGap="20px">
    <a class="partner-slider-item" [href]="getItem(i).link"
      *ngFor="let x of [].constructor(images_simultaneous); let i = index"
      target="_blank">
      <img [src]="getItem(i).imgurl" alt="">
    </a>
  </div>


  <div class="right-arrow" (click)="next()">
    <i class="far fa-chevron-right fa-3x right-arrow-icon"></i>
  </div>
</div>